import {getEnvConfig} from '@web-catalog/env';
import wretch from 'wretch';
import QueryStringAddon from 'wretch/addons/queryString';

type TSSPPayload = {
  format: string;
  publisherid: string;
  slotid: string;
  requestid: string;
  userid: string;
  vkid?: string;
  sessionid: string;
  device: {
    ua: string;
    language: string;
    deviceType: number;
    os?: string;
    osv?: string;
    connectionType?: number;
  };
  site: {
    url: string;
    title: string;
    referrer: string;
    domain?: string;
  };
};

export type TSSPResponse = {
  seat: string;
  publisherid: string;
  slotid: string;
  campaignid: string;
  creativeid: string;
  creative: string;
  price: number;
  nurl: string;
  iurl: string;
  load: string;
  impression: string;
  click: string;
  format: string;
};

const sspApi = wretch().options({cache: 'no-store'}).addon(QueryStringAddon);

export const getSspAd = async (payload: TSSPPayload) => {
  return sspApi
    .url(getEnvConfig().SSP_URL)
    .url('/ads')
    .post(payload)
    .json<TSSPResponse>();
};
